<template>
  <div class="form-group" :class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <input v-if="mask != ''" type="text" class="form-control" :class="inputClasses"
           :value="value"
           v-mask="mask"
           @input="updateValue($event.target.value)"
           @blur="blur($event.target.value)"
           @keypress.enter="enter()"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :autocomplete="name"

    >
    <input v-else="" type="text" class="form-control" :class="inputClasses"
           :value="value"
           @input="updateValue($event.target.value)"
           @blur="blur($event.target.value)"
           @keypress.enter="enter($event.target.value)"
           :name="name"
           :required="required"
           :disabled="disabled"
           :placeholder="placeholder"
           :autocomplete="name"

    >
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputText',
    props: {
      name: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
      required: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      error: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      },
      mask: {
        type: [String, Object],
        default: ''
      },
      inputClasses: {
        type: String,
        default: ''
      }
    },
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      },
      blur (value) {
        this.$emit('blur', value)
      },
      enter (value) {
        this.$emit('enter', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputText.vue?ea64d638